module.exports = "textarea.json-string{height:200px;font-family:monospace;font-size:9pt}\n"